import React, { Component } from 'react';
import withStyles from '@mui/styles/withStyles';

import { Button, Grid, Typography } from '@mui/material';

const styleSheet = theme => ({
  root: {
    flexGrow: 1
  }

});

class SystemDownAlert extends Component {
    
  componentDidMount() {
    if (this.props.auth.isAuthenticated()) {
      // Logout current user
      this.props.auth.logoutWithoutRedirect();
      window.location.reload();
    }
  }

  goToHome = () => {
    this.props.history.replace('/home');
  }

  render() {
    const classes = this.props.classes;

    return (
      <Grid container className={classes.root} spacing={2}>
        <Grid item xs={12} style={{marginTop: 24}}>
          <Grid container justifyContent="center">
            <Grid item >
            <Typography variant="h5" style={{marginRight: 16}}>
              The system is down for temporary maintenance, please check back later.
            </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Grid container justifyContent="center">
             <Grid item >
              <Button color="primary" variant="contained" onClick={(e) => {this.goToHome()}}>Try Again</Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  }
}
  
export default withStyles(styleSheet)(SystemDownAlert);